import React, { useState, useEffect } from 'react'
import { Layout } from 'antd'
import { Routes } from './components/Routes'
import { NavHeader } from './components/NavHeader'
import { SideNav } from './components/SideNav'
import './index.css'
import { useQueryParams } from 'hooks/useQueryParams'

export const App: React.FC = () => {
  const { collapseNav } = useQueryParams()
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    if (collapseNav === 'true') setCollapsed(true)
  }, [collapseNav])

  return (
    <Layout style={{ height: '100vh', width: '100vw', overflowY: 'auto' }}>
      <SideNav collapsed={collapsed} />
      <Layout style={{ background: '#fff', overflowY: 'auto' }}>
        <NavHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        <Layout.Content style={{ padding: '32px' }}>
          <Routes />
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
